export const ErrorsConfig = {
    SERVER_ERROR: {
        MESSAGE: "popup_msg.server_error"
    },
    SESSION_ERROR: {
        MESSAGE: "popup_msg.session_desc"
    }
}
